/**
 * Copyright © 2026 Adnuntius AS.
 */
export const bidUpdateDebug = [];
